
import { Box, Button, Card, CardActions, CardHeader, Chip, Divider, Table, TableBody, TableCell, TableHead, TableRow } from '@mui/material';
import { ArrowRightIcon } from '@phosphor-icons/react/dist/ssr/ArrowRight';

export default function DsTable({ title = "Table", columns = [], data = [], onViewAll }) {
    return (
        <Card sx={{ height: '100%', width: '100%' }}>
            <CardHeader title={title} />
            <Divider />
            <Box sx={{ overflowX: 'auto' }}>
                <Table sx={{ minWidth: 800 }}>
                    <TableHead>
                        <TableRow>
                            {columns.map((col) => (
                                <TableCell key={col.id} sortDirection={col.sortDirection}>
                                    {col.label}
                                </TableCell>
                            ))}
                        </TableRow>
                    </TableHead>
                    <TableBody>
                        {data.map((row, rowIndex) => (
                            <TableRow hover key={row.id || rowIndex}>
                                {columns.map((col) => (
                                    <TableCell key={col.id}>
                                        {col.render ? col.render(row) : row[col.id]}
                                    </TableCell>
                                ))}
                            </TableRow>
                        ))}
                    </TableBody>
                </Table>
            </Box>
            <Divider />
            {onViewAll && (
                <CardActions sx={{ justifyContent: 'flex-end' }}>
                    <Button
                        color="inherit"
                        endIcon={<ArrowRightIcon fontSize="var(--icon-fontSize-md)" />}
                        size="small"
                        variant="text"
                        onClick={onViewAll}
                    >
                        View all
                    </Button>
                </CardActions>
            )}
        </Card>
    );
}
